import { render, staticRenderFns } from "./procedure-template-menu.vue?vue&type=template&id=171cfba2&"
import script from "./procedure-template-menu.vue?vue&type=script&lang=js&"
export * from "./procedure-template-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports